// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface GenderDTO extends EntitySelectorDTO { 
	id: number;
	abbreviation: string | null;
	name: string | null;
}

const GenderDTO = {
    className: 'GenderDTO',
    create: (initValues?: Partial<GenderDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: 0,
			abbreviation: "",
			name: "",
        },
        initValues);
    },
	id: 'id',
	abbreviation: 'abbreviation',
	name: 'name',
};

export default GenderDTO;